<!--
 * @Author: jpf
 * @Date: 2023-02-13 17:26:53
 * @LastEditors: jpf
 * @LastEditTime: 2023-02-13 17:26:53
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>invoice SDK</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/invoice-sdk/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "2.0.3",
          linkList: [
            ur + "2.0.3/index.js",
            ur + "2.0.3/invoiceImportSdk.common.js"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListInvoice.vue